<script setup>
import { format } from '@formkit/tempo'

defineProps(['article'])
</script>

<template>
	<div class="item mx-auto flex break-inside-avoid flex-col gap-4 text-default hover:cursor-pointer lg:max-w-[600px]">
		<div class="relative flex w-fit rounded-big border border-border-default bg-bg p-3">
			<img class="aspect-video w-full rounded-big object-cover" alt="" :src="article.image" />
			<div class="border-line animation left-[-1px]" />
			<div class="border-line animation right-[-1px]" />
		</div>
		<div class="flex items-center gap-2">
			<span class="label-small outlined w-fit opacity-70">{{ format(article.published_at, 'full') }}</span>
			<span class="label-small inverse" v-if="article.category?.name">{{ article.category.name }}</span>
		</div>
		<h4 class="animation uppercase">
			{{ article.title }}
		</h4>
		<p class="md opacity-50">{{ article.snippet }}</p>
	</div>
</template>

<style scoped>
.item:hover h4 {
	@apply text-purple-base;
}

.border-line {
	@apply absolute top-[15%] h-[70%] w-[1px] bg-bg;
}

.item:hover .border-line {
	@apply top-[10%] h-[80%];
}
</style>
